import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * ProtectedRoute - Wraps routes that require authentication
 *
 * Redirects to /login if not logged in
 * Redirects to / if requireAdmin is true and user is not admin
 *
 * @param {object} props - Component props
 * @param {React.ReactNode} props.children - The route content to render if authorized
 * @param {boolean} props.requireAdmin - If true, requires user to be an admin
 */
export function ProtectedRoute({ children, requireAdmin = false }) {
  const { isLoggedIn, isAdmin, loading } = useAuth();
  const location = useLocation();

  console.log('[ProtectedRoute] Check - loading:', loading, 'isLoggedIn:', isLoggedIn, 'isAdmin:', isAdmin);

  if (loading) {
    console.log('[ProtectedRoute] Still loading, showing spinner');
    return (
      <div className="text-center" style={{ marginTop: '100px' }}>
        <h3>
          <i className="fa fa-spinner fa-pulse fa-2x"></i>
        </h3>
        <h3 className="startup-message">Loading...</h3>
      </div>
    );
  }

  if (!isLoggedIn) {
    console.log('[ProtectedRoute] Not logged in, redirecting to /login');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requireAdmin && !isAdmin) {
    console.log('[ProtectedRoute] Not admin, redirecting to /');
    return <Navigate to="/" replace />;
  }

  console.log('[ProtectedRoute] Access granted, rendering children');
  return children;
}

export default ProtectedRoute;
